/* Shared by browser, desktop and server. Server context always comes from trusted team records. */
const PRESETS = [
 {id:'personal',label:'Personal & Player',description:'Your events, requests, assignments and explicitly requested reviews.'},
 {id:'coachAnalyst',label:'Coach & Analyst',description:'New VOD uploads, Team Stats and coaching summaries.'},
 {id:'administration',label:'Team Owner, Manager & Team Payee',description:'Membership, roles, permissions and team administration.'},
 {id:'payee',label:'Payee',description:'Payment, subscription and team capacity updates.'},
];
const RAIL_ONLY=new Set(['focusPoint','improvementAssigned','improvementStatus','coachNoteAdded','noteAdded']);
const CATEGORIES={videoUpload:'coachAnalyst',teamStatsAdded:'coachAnalyst',expectationsAcknowledged:'administration',teamMemberJoined:'administration',teamAdministration:'administration',availabilityComplete:'administration',storageWarning:'payee',billingPromoExpiringSoon:'payee',billingUpdate:'payee',payerApproval:'payee'};
const keyFor=type=>['eventEdited','eventRemoved','eventCancelled'].includes(type)?'eventAdded':type==='teamDisbandScheduled'?'teamAdministration':type;
const ids=value=>Array.isArray(value)?value.map(item=>typeof item==='string'?item:item?.uid||item?.userId).filter(Boolean):[];
function contextFor(uid,team={},subscription={}) {
 const raw=team.teamRoles?.[uid],role=String(raw?.role||raw||'').trim().toLowerCase();
 const owner=Boolean(uid)&&uid===(team.teamLeaderId||team.ownerUid||team.ownerId||team.leaderUid||team.createdByUid);
 const manager=owner||['manager','manger','owner','leader'].includes(role)||ids(team.managerUids).includes(uid);
 const currentPayers=Array.isArray(subscription.selectedPayers)?ids(subscription.selectedPayers):ids(subscription.payerUids||team.billingPolicyV3?.payerUids);
 const payee=currentPayers.includes(uid)||ids(subscription.nextCycleSelectedPayers).includes(uid);
 return {personal:true,coachAnalyst:['coach','analyst'].includes(role),administration:manager||payee,payee,owner,manager,role};
}
function storedPreferences(value) {
 const raw=value&&typeof value==='object'?value:{},source=raw.version===2?raw.overrides:raw.types,overrides={};
 // Legacy flags are saved choices. Never silently discard them during migration.
 for(const [type,channels] of Object.entries(source||{})) {
  if(typeof channels==='boolean'){overrides[keyFor(type)]={inApp:channels,push:channels,discord:channels};continue;}
  if(!channels||typeof channels!=='object')continue;
  const next=Object.fromEntries(['inApp','push','discord'].filter(channel=>typeof channels[channel]==='boolean').map(channel=>[channel,channels[channel]]));
  if(Object.keys(next).length)overrides[keyFor(type)]=next;
 }
 return {version:2,masterEnabled:raw.masterEnabled!==false,followTeamEvents:raw.followTeamEvents===true,includePastEventChanges:raw.includePastEventChanges===true,presetOverrides:Object.fromEntries(PRESETS.filter(item=>typeof raw.presetOverrides?.[item.id]==='boolean').map(item=>[item.id,raw.presetOverrides[item.id]])),overrides};
}
function enabled(value,type,channel,context={}) {
 type=keyFor(type);
 if(RAIL_ONLY.has(type))return false;
 const prefs=storedPreferences(value);
 if(!prefs.masterEnabled)return false;
 const manual=prefs.overrides[type]?.[channel];if(typeof manual==='boolean')return manual;
 const preset=CATEGORIES[type]||'personal';
 return prefs.presetOverrides[preset]??(preset==='personal'||context[preset]===true);
}
// Only call this on database data, never on computed UI flags. Older installed
// clients still write sparse `types` patches; retain those explicit choices.
function readPreferences(value) {
 const stored=storedPreferences(value);
 if(value?.version!==2||!value.types)return stored;
 const legacy=storedPreferences({types:value.types});
 for(const [type,channels] of Object.entries(legacy.overrides))stored.overrides[type]={...stored.overrides[type],...channels};
 return stored;
}
const notificationPolicy={PRESETS,RAIL_ONLY,CATEGORIES,keyFor,contextFor,storedPreferences,readPreferences,enabled};
export default notificationPolicy;
